import React from "react";

/** Five stars for a 0–5 score (halves shown as a half star); the number itself for screen readers. */
export default function Stars({ score, showValue = false }) {
  const value = Number(score) || 0;
  return (
    <span className="rtg-stars" role="img" aria-label={value ? `${value} out of 5` : "Not rated"} title={value ? `${value} / 5` : "Not rated"}>
      {[1, 2, 3, 4, 5].map((n) => {
        const icon = value >= n ? "fas fa-star" : value >= n - 0.5 ? "fas fa-star-half-alt" : "far fa-star";
        return <i key={n} className={`${icon}${value >= n - 0.5 ? " is-on" : ""}`} aria-hidden="true" />;
      })}
      {showValue && value > 0 && <span className="rtg-stars__value">{value.toFixed(1)}</span>}
    </span>
  );
}
